module.exports = __webpack_public_path__ + "static/media/Delete.fe8416fe.svg";